/**
 * A "Read more"/"Read less" toggle for a truncated text block. Swaps a
 * plain-text preview for the full content in place; no external deps.
 */
class DdReadMore extends HTMLElement {
  connectedCallback() {
    this.preview = this.querySelector('[data-dd-read-more-preview]');
    this.body = this.querySelector('[data-dd-read-more-body]');
    this.button = this.querySelector('[data-dd-read-more-button]');
    this.button?.addEventListener('click', this.toggle);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
  }

  toggle = () => {
    const expand = this.dataset.expanded !== 'true';

    this.dataset.expanded = String(expand);
    this.button?.setAttribute('aria-expanded', String(expand));
    if (this.preview) this.preview.hidden = expand;
    if (this.body) this.body.hidden = !expand;
  };
}

if (!customElements.get('dd-read-more')) {
  customElements.define('dd-read-more', DdReadMore);
}
